import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

interface StatusUpdatePayload {
  status: string;
}
interface IndentPayload {
  productType: string | null;
  storeId: string | null;
  date: string | null;
}
@Injectable({
  providedIn: 'root',
})
export class IndentListService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Get ident list for a specific location
   * @param locationId - The ID of the location/store
   * @returns Observable with ident list data
   */
  getReplenishmentSuggestions(storeId: string): Observable<any> {
    const params = new HttpParams().set('storeId', storeId);
    return this.http.get(`${this.apiUrl}/replenishment/suggestions`, {
      params,
    });
  }

  getReplenishmentSuggestionsById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/replenishment/suggestions/${id}`);
  }

  createIndent(payload: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/indent`, payload);
  }

  getIndentByStoreIds(
  storeIds?: string | string[],
  fromDate?: string,
  status?: string
): Observable<any> {
  let params = new HttpParams();

  // Optional: fromDate (format: 2025-10-01)
  if (fromDate) {
    params = params.set('fromDate', fromDate);
  }

  // Optional: status (e.g., pending, completed, cancelled)
  if (status) {
    params = params.set('status', status);
  }

  // Optional: storeIds (can be string or array)
  if (storeIds) {
    if (typeof storeIds === 'string') {
      params = params.set('storeIds', storeIds);
    } else if (Array.isArray(storeIds)) {
      for (const id of storeIds) {
        params = params.append('storeIds', id);
      }
    }
  }

  return this.http.get(`${this.apiUrl}/indent`, { params });
}


  getIndentById(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/indent/${id}`);
  }
  updateIndentStatus(
    id: string,
    payload: StatusUpdatePayload
  ): Observable<any> {
    return this.http.patch(`${this.apiUrl}/indent/${id}`, payload);
  }

  getFilteredIndentList(payLoad:any){
    return this.http.post(`${this.apiUrl}/catalog/filter-variants`, payLoad);
  }
}
